/* Livena — kalme reveal-on-scroll.
   Alleen de INHOUD (tekst) faadt zacht omhoog; de sectie-achtergrond
   blijft staan. Progressive enhancement: zonder JS blijft alles zichtbaar.
   Sticky-secties worden overgeslagen. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('lvr-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  function hasBackground(el) {
    var cs = window.getComputedStyle(el);
    if (cs.backgroundImage && cs.backgroundImage !== 'none') return true;
    var bc = cs.backgroundColor;
    if (bc && bc !== 'transparent' && bc !== 'rgba(0, 0, 0, 0)') return true;
    return false;
  }

  function isSticky(el) {
    return !!el.querySelector('.sticky-content--desktop, sticky-add-to-cart, [data-sticky-state]');
  }

  /* Bepaal de inhoud-elementen om te animeren, zonder achtergrondlagen.
     Heeft een direct kind een eigen achtergrond (full-bleed sectiekleur),
     dan animeren we juist dat kind z'n inhoud, zodat de achtergrond stil blijft. */
  function contentTargets(section) {
    var out = [];
    var kids = section.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.nodeType !== 1) continue;
      if (k.classList.contains('section-background')) continue;
      if (hasBackground(k)) {
        var inner = k.children;
        for (var j = 0; j < inner.length; j++) {
          var c = inner[j];
          if (c.nodeType === 1 && !c.classList.contains('section-background')) out.push(c);
        }
      } else {
        out.push(k);
      }
    }
    return out;
  }

  function prep() {
    var vh = window.innerHeight || 800;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (isSticky(sec)) continue;
      var targets = contentTargets(sec);
      for (var t = 0; t < targets.length; t++) {
        var el = targets[t];
        if (el.classList.contains('lvr') || el.classList.contains('lvr-in')) continue;
        if (el.getBoundingClientRect().top > vh * 0.82) {
          el.classList.add('lvr');
          io.observe(el);
        }
      }
    }
  }

  if (document.readyState !== 'loading') prep();
  else document.addEventListener('DOMContentLoaded', prep);

  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(prep);
  });
})();
